import { useState } from "react";
import { Message, Card } from "@arco-design/web-react";
import styles from "./index.module.less";
import {CheckCodeModal} from "../../../components";
import {userSelf} from "../../../store"

export default function Delete() {
  const handleUserDelete = async (formData) => {
    const {checkCode} = formData
    if(!checkCode){
        Message.error("请输入验证码")
        return
    }
    await userSelf.deleteUser(checkCode)
  }
  return (
    <Card title={"用户注销"} className={styles.account_delete}>
      <div className={styles.container}>
        <div className={styles.info}>
          <div>
            <span className={styles.h1}>
              在你申请注销“每日美刊”帐号之前，请你认真阅读、理解并同意《每日美刊帐号注销须知》（以下称&quot;注销须知&quot;）。【特别提示】在此善意提醒你，注销“每日美刊”帐号为不可恢复的操作，注销帐号后你将无法再使用该“每日美刊”帐号或找回账号的个人资料和历史信息
              <span className={styles.inline_strong_font}>
                （即使你使用相同的手机号码或之前绑定过的其他账号体系再次注册并登录“每日美刊”软件或网站）。
              </span>
            </span>
          </div>
          <div>
            <span className={styles.h2}>
              建议你在注销前自行备份“每日美刊”软件帐号相关的所有信息（或可发送邮件至service@imeikan.com向工作人员要求下载个人信息，我们将在收到邮件内15个工作日内与你取得联系），并请确认与该“每日美刊”帐号相关的所有服务均已进行妥善处理。注销成功后，我们将删除你的个人信息，或对其进行匿名化处理。
            </span>
          </div>
          <div>
            <span className={styles.font_strong}>
              1.我们对你注销“每日美刊”帐号的决定深表遗憾。如果你仍执意注销帐号，你的帐号需同时满足以下条件：
            </span>
            <span className={styles.h3}>
              1.1帐号处于安全状态：帐号处于正常使用状态，无被盗风险；
            </span>
            <span className={styles.h3}>1.2帐号无任何纠纷，包括投诉举报或被投诉举报；</span>
            <span className={styles.h3}>
              1.3帐号处于正常使用状态：该账号正常使用，没有被处罚或封禁。
            </span>
          </div>
          <div>
            <span className={styles.font_strong}>
              2.在你的微专栏注销期间，如果该微专栏涉及争议纠纷
            </span>
            <span className={styles.h3}>
              （包括但不限于：投诉、举报、诉讼、仲裁、国家有权机关调查等），你知晓并理解，我们有权自行决定是否终止本微专栏的注销而无需另行得到你的同意。
            </span>
          </div>
          <div>
            <span className={styles.font_strong}>
              3.注销“每日美刊”帐号，你将无法再使用该“每日美刊”帐号，也将无法找回该“每日美刊”帐号中及与帐号相关的任何内容或信息，包括但不限于：
            </span>
            <span className={styles.h3}>
              3.1该“每日美刊”帐号的个人资料和历史信息（包括但不限于头像、昵称、订阅/创建的每日美刊专栏、订阅、点赞、收藏、发布、评论等）都将无法找回；
            </span>
            <span className={styles.h3}>
              3.2该“每日美刊”帐号为创建者身份的微专栏（如有）都将被一并注销，且无法找回，共创者（如有）均会收到你注销账号的消息通知，如你不想一并注销该“每日美刊”帐号为创建者身份的微专栏，请提前完成创建者身份的转让；
            </span>
            <span className={styles.h3}>3.3你将无法登录、使用该“每日美刊”帐号；</span>
          </div>
          <div>
            <span className={styles.font_strong}>
              4.注销该“每日美刊”帐号并不代表注销前的帐号中的行为和相关责任得到豁免或减轻。
            </span>
          </div>
        </div>
        <div className={styles.button_container}>
          <CheckCodeModal
              okText="确认注销"
              buttonText={"申请注销"}
              title={"确认注销后无法找回，确保您已阅读完注销说明"}
              smsType={"userDelete"}
              onOk={handleUserDelete}
          />
        </div>
      </div>
    </Card>
  );
}
